import { useEffect, useRef, useState } from 'react';
import { Modal } from '../../components/Modal';
import { ANCHOR_SCREENSHARE } from '../../game/overlayAnchors';
import { useOverlayAnchor } from '../../hooks/useOverlayAnchor';
import { useMediaStore, type PeerMedia } from '../../stores/mediaStore';
import './av.css';

/**
 * Geteilte Bildschirme als schwebende Fenster in der Welt — verankert ueber
 * dem teilenden Avatar, per Klick als grosses Modal.
 */
export function ScreenWindows() {
  const peers = useMediaStore((s) => s.peers);
  const callPanelOpen = useMediaStore((s) => s.callPanelOpen);
  const sharing = Object.values(peers).filter((p) => p.streams.screen);

  // Waehrend das CallPanel offen ist, zeigt es die Screens — kein Doppel-UI
  if (callPanelOpen) return null;

  return (
    <>
      {sharing.map((peer) => (
        <ScreenWindow key={peer.peerId} peer={peer} />
      ))}
    </>
  );
}

function ScreenWindow({ peer }: { peer: PeerMedia }) {
  const ref = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const bigVideoRef = useRef<HTMLVideoElement>(null);
  const [enlarged, setEnlarged] = useState(false);
  useOverlayAnchor(ref, { kind: 'player', id: peer.peerId }, ANCHOR_SCREENSHARE);

  const stream = peer.streams.screen ?? null;

  useEffect(() => {
    if (videoRef.current) videoRef.current.srcObject = stream;
  }, [stream]);

  useEffect(() => {
    if (enlarged && bigVideoRef.current) bigVideoRef.current.srcObject = stream;
  }, [enlarged, stream]);

  return (
    <>
      <div ref={ref} className="screen-window" data-player={peer.peerId}>
        <button
          className="screen-window__hit"
          onClick={() => setEnlarged(true)}
          title={`Bildschirm von ${peer.displayName} vergroessern`}
        >
          <video ref={videoRef} className="screen-window__video" autoPlay playsInline muted />
        </button>
        <span className="screen-window__label">🖥️ {peer.displayName}</span>
      </div>
      {enlarged && (
        <Modal title={`Bildschirm von ${peer.displayName}`} onClose={() => setEnlarged(false)} wide>
          <video ref={bigVideoRef} className="screen-window__video--big" autoPlay playsInline muted />
        </Modal>
      )}
    </>
  );
}
